import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-seviye-cubugu',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="seviye-kapsayici" [style.height.px]="yukseklik()">
      <div class="seviye-etiketler">
        <span class="etiket ust">100</span>
        <span class="etiket orta">50</span>
        <span class="etiket alt">0</span>
      </div>
      <div class="seviye-cubuk">
        <div class="seviye-arka"></div>
        <div class="seviye-dolgu"
          [style.height.%]="clampYuzde()"
          [style.background]="gradyan()"
        ></div>
        <span class="seviye-deger" [style.bottom.%]="clampYuzde()" [style.color]="renk()">
          {{ clampYuzde() }}%
        </span>
      </div>
    </div>
  `,
  styles: [`
    :host { display: inline-block; }
    .seviye-kapsayici { display: flex; gap: 6px; min-width: 48px; }
    .seviye-etiketler {
      display: flex; flex-direction: column; justify-content: space-between;
      font-size: 10px; opacity: 0.45; text-align: right; padding: 2px 0;
    }
    .seviye-cubuk {
      position: relative; flex: 1; min-width: 28px; border-radius: 6px; overflow: hidden;
    }
    .seviye-arka {
      position: absolute; inset: 0; background: rgba(128,128,128,0.1); border-radius: 6px;
    }
    .seviye-dolgu {
      position: absolute; bottom: 0; left: 0; right: 0; border-radius: 6px;
      transition: height 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .seviye-deger {
      position: absolute; left: 50%; transform: translate(-50%, 50%);
      font-size: 12px; font-weight: 700; white-space: nowrap;
      transition: bottom 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }
  `],
})
export class SeviyeCubuguComponent {
  yuzde = input(0);
  renk = input('#1890ff');
  yukseklik = input(120);

  clampYuzde = computed(() => Math.max(0, Math.min(100, this.yuzde())));

  gradyan = computed(() => {
    const r = this.renk();
    return `linear-gradient(to top, ${r}, ${r}dd)`;
  });
}
